import Shepherd from 'shepherd.js';
import store from '.';

export const namespaced = true;
const NS_NAME = 'onboarding';

const LS_STATE_NAME = 'onboarding_completed';

const getCompletedState = () => {
  const lsState = localStorage.getItem(LS_STATE_NAME);
  let state: boolean;

  if (lsState === 'true') {
    state = true;
  } else if (lsState === 'false') {
    state = false;
  }

  if (state !== undefined) {
    return state;
  }

  localStorage.setItem(LS_STATE_NAME, 'false');
  return false;
};

const setCompletedState = (state: boolean) => {
  let lsState: string;

  if (state === true) {
    lsState = 'true';
  } else if (state === false) {
    lsState = 'false';
  }

  localStorage.setItem(LS_STATE_NAME, lsState);
};

const tour = new Shepherd.Tour({
  tourName: 'Onboarding',
  confirmCancel: false,
  useModalOverlay: true,
  exitOnEsc: true,
  keyboardNavigation: true,
  classPrefix: 'sb-onboarding',
  defaultStepOptions: {
    arrow: false,
    classes: 'sb_onboarding',
    modalOverlayOpeningPadding: 8,
    modalOverlayOpeningRadius: 4,
    scrollTo: { behavior: 'smooth', block: 'nearest', inline: 'nearest' },
    cancelIcon: { enabled: true },
    popperOptions: {
      modifiers: [
        { name: 'offset', options: { offset: [0, 24] } },
        {
          name: 'preventOverflow',
          options: {
            mainAxis: true,
            altAxis: true,
            padding: 24,
          },
        },
        { name: 'focusAfterRender', enabled: false },
      ],
    },
  },
  steps: [
    {
      id: 'step1',
      title: '<span class="bold">Stap </span><span class="sb_steps"><span class="bold">1</span><span>/3</span></span>',
      text: `<p>Voer jouw gewenste afmeting in.</p><div class="sb_onboarding_background_image"><div class="sb_icon"><svg role="img"><use xlink:href="#icon_size" /></svg></div></div>`,
      attachTo: {
        element: '.sb_dimensions_labels',
        on: 'bottom',
      },
      buttons: [
        {
          text:
            '<span class="sb_onboarding_button"><span>Volgende</span><span class="sb_icon"><svg role="img"><use xlink:href="#icon_arrow-right" /></svg></span></span>',
          action: () => store.commit(`${NS_NAME}/setStep`, 1),
        },
      ],
    },
    {
      id: 'step2',
      title: '<span class="bold">Stap </span><span class="sb_steps"><span class="bold">2</span><span>/3</span></span>',
      text: `<p>Kies uit Naadloos Behang of een Foto Frame.</p><div class="sb_onboarding_background_image"><div class="sb_icon"><svg role="img"><use xlink:href="#icon_frame-canvas" /></svg></div></div>`,
      attachTo: {
        element: '.sb_switch-mode_label',
        on: 'bottom',
      },
      buttons: [
        {
          text:
            '<span class="sb_onboarding_button"><span>Volgende</span><span class="sb_icon"><svg role="img"><use xlink:href="#icon_arrow-right" /></svg></span></span>',
          action: () => store.commit(`${NS_NAME}/setStep`, 2),
        },
      ],
    },
    {
      id: 'step3',
      title: '<span class="bold">Stap </span><span class="sb_steps"><span class="bold">3</span><span>/3</span></span>',
      text: `<p>Maak het persoonlijk en uniek door tekst en/of een logo toe te voegen.</p><div class="sb_onboarding_background_image"><div class="sb_icon"><svg role="img"><use xlink:href="#icon_design" /></svg></div></div>`,
      attachTo: {
        element: '.sb_footer_options',
        on: 'top',
      },
      buttons: [
        {
          text:
            '<span class="sb_onboarding_button"><span>Begin met ontwerpen</span><span class="sb_icon"><svg role="img"><use xlink:href="#icon_arrow-right" /></svg></span></span>',
          action: () => store.commit(`${NS_NAME}/finishOnboarding`),
        },
      ],
    },
  ],
});

tour.on('cancel', () => {
  store.commit(`${NS_NAME}/finishOnboarding`, true);
});

export const state = () => ({
  completed: getCompletedState(),
  getCompletedState,
  active: false,
  step: 0,
});

export const mutations = {
  startOnboarding(state) {
    state.active = true;
    tour.start();
  },
  stopOnboarding(state) {
    state.active = false;
    tour.complete();
  },
  finishOnboarding(state) {
    state.active = false;
    setCompletedState(true);
    tour.complete();
  },
  setActive(state, data) {
    state.active = data;
  },
  setStep(state, data) {
    if (!data) {
      state.active = false;
      return;
    }

    state.active = true;
    state.step = data;
    tour.show(tour.steps[data].id);
  },
};
